module.exports = __webpack_public_path__ + "assets/d9df87e8718ea273cc0bed5bb6efc896.mp3";